/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { EntityInputDialogComponent } from '@gh/common-internal-shared';
import { createDialogRoute } from '@gh/common-shared';

import { ChecklistListBusinessService } from '../../resources/checklist-business.service';

export const ChecklistDetailsDialog = createDialogRoute({ // tslint:disable-line:variable-name
  component: EntityInputDialogComponent,
  init: ChecklistListBusinessService,
});
